/*============================================================================
  Elenni Aulic promo — flat % sync to selected variant
  online-fs (Meir sitewide 25% compare): variant.price = sale, compare_at = RRP
==============================================================================*/
(function () {
  function priceCents(variant) {
    if (!variant) return null;
    if (typeof variant.price === 'number') return variant.price;
    if (variant.price && variant.price.amount != null) {
      return Math.round(parseFloat(variant.price.amount) * 100);
    }
    return null;
  }
  function compareAtCents(variant) {
    if (!variant) return null;
    if (typeof variant.compare_at_price === 'number') return variant.compare_at_price;
    if (variant.compare_at_price && variant.compare_at_price.amount != null) {
      return Math.round(parseFloat(variant.compare_at_price.amount) * 100);
    }
    // Some payloads use compareAtPrice
    if (typeof variant.compareAtPrice === 'number') return variant.compareAtPrice;
    if (variant.compareAtPrice && variant.compareAtPrice.amount != null) {
      return Math.round(parseFloat(variant.compareAtPrice.amount) * 100);
    }
    return null;
  }
  function formatMoney(cents) {
    var n = (Number(cents) || 0) / 100;
    try {
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
      return new Intl.NumberFormat('en-AU', { style: 'currency', currency: currency }).format(n);
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }
  // Crawl-audit-2 fix 20261009: theme CSS sets display on the promo block, so [hidden] alone did not hide it
  function setHidden(promo, hide) {
    promo.hidden = hide;
    promo.style.display = hide ? 'none' : '';
  }
  function applyVariant(promo, variant) {
    // Crawl-audit-2 fix 20261009: option combination with no variant (theme shows "Unavailable") -> hide promo, never stale/$0 prices
    if (!variant) { setHidden(promo, true); return; }
    var cents = priceCents(variant);
    if (cents == null) { setHidden(promo, true); return; }
    // Crawl-audit fix 20261008: no promo price/saving for $0 (price on request) variants
    if (cents <= 0) { setHidden(promo, true); return; }
    setHidden(promo, false);
    var mode = promo.getAttribute('data-price-mode') || '';
    var flatOff = parseInt(promo.getAttribute('data-flat-off') || '20', 10);
    var saleCents;
    var rrpCents;
    if (mode === 'compare' || promo.getAttribute('data-elenni-badge') === 'online-fs') {
      saleCents = cents;
      rrpCents = compareAtCents(variant);
      if (rrpCents == null || rrpCents <= saleCents) {
        rrpCents = Math.round((saleCents * 100) / (100 - flatOff));
      }
    } else {
      rrpCents = cents;
      saleCents = window.ElenniPromo.saleCents(cents, flatOff); /* rounding-fix 20261020: shared rule (layout/theme.liquid) */
    }
    var saveCents = Math.max(0, rrpCents - saleCents);
    var rrp = promo.querySelector('[data-elenni-promo-rrp]');
    var sale = promo.querySelector('[data-elenni-promo-sale]');
    var save = promo.querySelector('[data-elenni-promo-save]');
    if (rrp) rrp.textContent = formatMoney(rrpCents);
    if (sale) sale.textContent = formatMoney(saleCents);
    if (save) {
      save.textContent = 'You save ' + formatMoney(saveCents);
    }
  }
  function bindPromo(promo) {
    if (promo.dataset.elenniPromoBound === '1') return;
    var sectionId = promo.getAttribute('data-section-id');
    var productId = promo.getAttribute('data-product-id');
    if (!productId) return;
    promo.dataset.elenniPromoBound = '1';
    if (sectionId) {
      document.addEventListener('variant:change:' + sectionId + ':' + productId, function (event) {
        var detail = event.detail || {};
        if (detail.loading) return;
        applyVariant(promo, detail.variant || null);
      });
    }
  }
  function scan() {
    document.querySelectorAll('.elenni-aulic-promo--pdp').forEach(bindPromo);
  }
  document.addEventListener('shopify:product:select', function (event) {
    var picker = event.target;
    if (!(picker instanceof HTMLElement)) return;
    var productId = picker.dataset.productId;
    var readVariant = function () {
      try {
        var el = picker.querySelector('[data-kit-selected-variant]');
        return JSON.parse((el && el.textContent) || 'null');
      } catch (e) { return null; }
    };
    var run = function (v) {
      document.querySelectorAll('.elenni-aulic-promo--pdp[data-product-id="' + productId + '"]').forEach(function (promo) {
        applyVariant(promo, v);
      });
    };
    if (event.promise && typeof event.promise.then === 'function') {
      event.promise.then(function () { run(readVariant()); }).catch(function () {});
    } else {
      run(readVariant());
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
